import React from "react";
import { Box, Divider } from "@mui/material";

// import { useLazyListShipmentForSendOutsQuery, } from "store/services/sendOutApi";
import SendOutShipmentItems from "./SendOutShipmentItems";
// import { useSendOutDetailContext } from "contexts/SendOutDetailContext";

const SendOutShipmentTab = ({ setTotalShipments }) => {
//   const { sendOutDetail } = useSendOutDetailContext();
//   const [fetchesShipments, { data: shipmentRes }] =
//   useLazyListShipmentForSendOutsQuery();

//   const totalShipments = shipmentRes?.totalItems ?? 0;

//   React.useEffect(() => {
//     if (sendOutDetail?._id) {
//       fetchesShipments({ customerId: sendOutDetail?._id });
//       if (setTotalShipments) setTotalShipments(totalShipments);
//     }
//   }, [
//     sendOutDetail?._id,
//     fetchesShipments,
//     setTotalShipments,
//     totalShipments,
//   ]);

  return (
    <>
      <Box display="flex" justifyContent="end" padding={3}></Box>
      <Divider />

      <SendOutShipmentItems />
    </>
  );
};

export default SendOutShipmentTab;
